import React from "react";
import { Icon } from "@iconify/react";
import Button from "../../Components/Button";
import { Typography } from "../../Components/Typography";
import { ATTACHMENT_LINK_FIELDS } from "./ideaFormConfig";

const EditableAttachmentLinks = ({ formValues, onFieldChange, onSave, saving, hideSaveButton = false }) => (
  <div className="flex flex-col gap-6">
    <div>
      <Typography as="h3" className="text-lg font-bold text-slate-900">
        Attached files
      </Typography>
      <Typography as="p" className="text-sm text-slate-500 mt-1">
        Add links to your idea video, pitch video, and supporting documents.
      </Typography>
    </div>

    <div className="flex flex-col gap-4">
      {ATTACHMENT_LINK_FIELDS.map(({ key, label, placeholder, icon }) => (
        <div
          key={key}
          className="rounded-xl border border-slate-200 bg-slate-50/50 p-4 flex flex-col gap-2"
        >
          <div className="flex items-center gap-2">
            <Icon icon={icon} className="h-4 w-4 text-violet-600" />
            <label className="text-sm font-semibold text-slate-800">{label}</label>
          </div>
          <input
            type="url"
            value={formValues[key] || ""}
            onChange={(e) => onFieldChange(key, e.target.value)}
            placeholder={placeholder}
            className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-200"
          />
        </div>
      ))}
    </div>

    {!hideSaveButton && (
      <div className="flex justify-end pt-2 border-t border-slate-100">
        <Button
          variant="primary"
          onClick={onSave}
          disabled={saving}
          className="bg-violet-600 hover:bg-violet-700"
          startIcon={
            saving ? (
              <Icon icon="lucide:loader-2" className="h-4 w-4 animate-spin" />
            ) : (
              <Icon icon="lucide:save" className="h-4 w-4" />
            )
          }
        >
          {saving ? "Saving..." : "Save links"}
        </Button>
      </div>
    )}
  </div>
);

export default EditableAttachmentLinks;
